import BsDivider from './index.vue'
export default BsDivider